import "./Navbar.css";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
    FaFacebookF,
    FaInstagram,
    FaBars,
    FaTimes,
} from "react-icons/fa";

import Logo from "../../assets/logos/logo_blanco_v++.svg";

function Navbar() {
    const [scrolled, setScrolled] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);

    // Detectar scroll
    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 50);
        };

        handleScroll();

        window.addEventListener("scroll", handleScroll, {
            passive: true,
        });

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    // Cerrar menú con Escape o al cambiar a escritorio
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                setMenuOpen(false);
            }
        };

        const handleResize = () => {
            if (window.innerWidth > 768) {
                setMenuOpen(false);
            }
        };

        window.addEventListener("keydown", handleKeyDown);
        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("keydown", handleKeyDown);
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    // Cerrar menú al seleccionar una opción
    const closeMenu = () => {
        setMenuOpen(false);
    };

    return (
        <header
            className={`navbar ${scrolled ? "navbar-scrolled" : ""} ${
                menuOpen ? "navbar-menu-open" : ""
            }`}
        >
            <div className="navbar-container">
                {/* LOGO */}
                <Link
                    to="/"
                    className="navbar-logo"
                    onClick={closeMenu}
                    aria-label="Vemasmas - Inicio"
                >
                    <img src={Logo} alt="Vemasmas" />
                </Link>

                {/* MENÚ DE ESCRITORIO */}
                <nav className="navbar-menu" aria-label="Navegación principal">
                    <Link to="/" onClick={closeMenu}>
                        Inicio
                    </Link>

                    <Link to="/empresa" onClick={closeMenu}>
                        Empresa
                    </Link>

                    <Link to="/nosotros" onClick={closeMenu}>
                        Nosotros
                    </Link>

                    <Link to="/grupo" onClick={closeMenu}>
                        Grupo
                    </Link>
                </nav>

                {/* REDES SOCIALES DE ESCRITORIO */}
                <div className="navbar-social">
                    <a
                        href="https://www.facebook.com/Vemasmasmx/?locale=es_LA"
                        aria-label="Facebook"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <FaFacebookF />
                    </a>

                    <a
                        href="https://www.instagram.com/vemasmasmx/"
                        aria-label="Instagram"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <FaInstagram />
                    </a>
                </div>

                {/* BOTÓN HAMBURGUESA */}
                <button
                    type="button"
                    className="navbar-toggle"
                    onClick={() => setMenuOpen((previous) => !previous)}
                    aria-label={
                        menuOpen ? "Cerrar menú" : "Abrir menú"
                    }
                    aria-expanded={menuOpen}
                    aria-controls="navbar-mobile-menu"
                >
                    {menuOpen ? <FaTimes /> : <FaBars />}
                </button>
            </div>

            {/* MENÚ MÓVIL */}
            {menuOpen && (
                <div
                    className="navbar-mobile-overlay"
                    onClick={closeMenu}
                >
                    <nav
                        id="navbar-mobile-menu"
                        className="navbar-mobile-menu"
                        aria-label="Navegación móvil"
                        onClick={(event) => event.stopPropagation()}
                    >
                        <span className="navbar-mobile-label">
                            NAVEGACIÓN
                        </span>

                        <Link to="/" onClick={closeMenu}>
                            <span>01</span>
                            Inicio
                        </Link>

                        <Link to="/empresa" onClick={closeMenu}>
                            <span>02</span>
                            Empresa
                        </Link>

                        <Link to="/nosotros" onClick={closeMenu}>
                            <span>03</span>
                            Nosotros
                        </Link>

                        <Link to="/grupo" onClick={closeMenu}>
                            <span>04</span>
                            Grupo
                        </Link>

                        <div className="navbar-mobile-divider" />

                        <div className="navbar-mobile-social">
                            <a
                                href="/"
                                aria-label="Facebook"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <FaFacebookF />
                            </a>

                            <a
                                href="/"
                                aria-label="Instagram"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <FaInstagram />
                            </a>
                        </div>

                        <p className="navbar-mobile-caption">
                            Innovamos para transformar.
                        </p>
                    </nav>
                </div>
            )}
        </header>
    );
}

export default Navbar;
